<template>
  <div>
    <div class="progress" v-if="uploadFileInfo.progress > 0" style="height: 1px;">
      <el-progress :percentage="uploadFileInfo.progress" :stroke-width="1" :show-text="false"></el-progress>
    </div>
    <div style="margin-bottom: 5px;" v-if="uploadFileInfo.progress > 0">
      <span>{{ uploadFileInfo.fileName }}</span>
    </div>
    <div>
      <el-button type="primary" size="small" @click="_uploadFile">
        <span>{{ $t('common.upload') }}</span>
      </el-button>
      <input type="file" class="file" accept="*" id="uploadFile" hidden @change="_chooseFile($event)">
    </div>
  </div>
</template>

<script>
import { uploadFile } from '@/api/common/uploadApi'

export default {
  name: 'UploadFile',
  props: {
    namespace: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      uploadFileInfo: {
        vedio: {},
        fileName: '',
        realFileName: '',
        progress: 0
      }
    }
  },
  methods: {
    _uploadFile() {
      document.getElementById('uploadFile').click()
    },
    _chooseFile(event) {
      const files = event.target.files
      if (files && files.length > 0) {
        const file = files[0]
        if (file.size > 1024 * 1024 * 20) {
          this.$message.error('文件大小不能超过 20MB!')
          return false
        }
        this.uploadFileInfo.fileName = file.name
        this._doUploadFile(file)
      }
    },
    _doUploadFile(file) {
      const formData = new FormData()
      formData.append('uploadFile', file)

      uploadFile(formData, {
        onUploadProgress: (progressEvent) => {
          const rate = progressEvent.loaded / progressEvent.total
          if (rate < 0.9) {
            this.uploadFileInfo.progress = (rate * 100).toFixed(2)
          }
        }
      }).then(response => {
        this.uploadFileInfo.progress = 100
        this.$message.success('文件上传成功')
        this.uploadFileInfo.fileName = response.url
        this.uploadFileInfo.realFileName = response.fileId
        this.$emit('notifyCert', this.uploadFileInfo)
      }).catch(error => {
        console.error('上传文件失败:', error)
        this.$message.error('上传文件失败')
      })
    },
    clearVedio() {
      this.uploadFileInfo = {
        vedio: {},
        fileName: '',
        realFileName: '',
        progress: 0
      }
    },
    notifyVedio(fileName) {
      this.uploadFileInfo.fileName = fileName
      this.uploadFileInfo.realFileName = fileName
      this.uploadFileInfo.progress = 100
    }
  }
}
</script>